module.exports = __webpack_public_path__ + "img/event.ace35717.jpg";